import React from 'react'
import cn from "classnames"
import PropTypes from 'prop-types'
import injectStyles from "react-jss"

const CategoryLabel = ({classes, color, className, category, size}) => (
    <div className={cn(classes.category, className, {
        [classes.small]: size === 'small',
        [classes.medium]: size === 'medium',
    })}>{category}</div>
)

CategoryLabel.propTypes = {
    category: PropTypes.string.isRequired,
}

export default injectStyles(theme => ({
    category: {
        textTransform: 'uppercase',
        ...theme.font.familyBoldStyle,
        lineHeight: theme.font.info.lineHeight,
        fontSize: 11,
        color: ({color, category, tags}) => color || theme.getArticleColor(category, tags),
        [theme.breakpoint("tablet")]: {
            fontSize: 12
        }
    },
    medium: {
        fontSize: 11,
        [theme.breakpoint("tablet")]: {
            fontSize: 12
        }
    }
}))(CategoryLabel)





// WEBPACK FOOTER //
// ./src/components/Widgets/CategoryLabel.js